import { ChangeDetectionStrategy, Component } from '@angular/core';
import { connectState } from '@examdojo/angular/util';
import { BannerComponent } from '@examdojo/core/ui/banner';
import { InformativeBannerService } from './informative-banner.service';

@Component({
  selector: 'dojo-informative-banner',
  imports: [BannerComponent],
  template: `
    @for (banner of state.bannerConfigs; track banner.key) {
      <dojo-banner [content]="banner.config" [dataTest]="'banner-' + banner.key" />
    }
  `,
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: { class: 'block' },
})
export class InformativeBannerComponent {
  constructor(private readonly informativeBannerService: InformativeBannerService) {}

  readonly state = connectState({
    bannerConfigs: this.informativeBannerService.bannerConfigs$,
  });
}
